import React from 'react';
import { Sun, Droplets, Moon, Activity } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Solution() {
  const steps = [{
    icon: Sun,
    title: 'Luz Matinal',
    desc: 'Reinicia tu ritmo circadiano dentro de los primeros 30 minutos al despertar para optimizar el cortisol.'
  }, {
    icon: Droplets,
    title: 'Balance Mineral',
    desc: 'Restaura la energía celular agotada con protocolos de hidratación dirigidos.'
  }, {
    icon: Activity,
    title: 'Glucosa Estable',
    desc: 'Secuencia simple de alimentos para evitar los picos que causan el caos hormonal.'
  }, {
    icon: Moon,
    title: 'Descanso Profundo',
    desc: 'Rutinas nocturnas diseñadas para reducir las hormonas del estrés y sanar a profundidad.'
  }];
  return <section id="method" className="py-20 md:py-32 bg-sage/30" data-id="element-129">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-130">
        <div className="max-w-3xl mx-auto text-center mb-14 md:mb-24" data-id="element-131">
          <FadeIn data-id="element-132">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-133">
              El Método
            </span>
            <h2 className="font-serif text-3xl md:text-6xl text-ink mb-6 md:mb-8" data-id="element-134">
              El Método del <em className="italic" data-id="element-135">1%</em>
            </h2>
            <p className="text-base md:text-lg text-ink-light font-light leading-relaxed" data-id="element-136">
              Sanar no requiere dietas extremas ni entrenamientos agotadores.
              Requiere consistencia. Al hacer pequeños cambios estratégicos del
              1% en tu rutina diaria, generas resultados que se acumulan y
              transforman tu salud hormonal desde adentro hacia afuera.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12" data-id="element-137">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-138">
              <div className="flex flex-col items-center text-center" data-id="element-139">
                <span className="font-serif text-5xl italic text-sand-dark/30 mb-6 block" data-id="element-140">
                  0{index + 1}
                </span>
                <div className="mb-6 text-ink" data-id="element-141">
                  <step.icon strokeWidth={1} className="w-10 h-10" data-id="element-142" />
                </div>
                <h3 className="font-serif text-2xl mb-4 text-ink" data-id="element-143">
                  {step.title}
                </h3>
                <p className="text-sm text-ink-light font-light leading-relaxed" data-id="element-144">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}